import React, { FunctionComponent } from "react";
import { INodeConfigPropertiesProps } from "../NodeTypes/PropertyTypeDefinitions";
import { Button } from "@plex/react-components";
import "./NodePropertiesForm.scss";
import { useFunctionSubscriber } from "../FunctionSubscriberContext/FunctionSubscriberContext";

export const ViewPlexAgentDetailsButton: FunctionComponent<INodeConfigPropertiesProps> = (props) => {
  const plexAgentId = props.node?.data.nodeProperties?.plexAgentId ?? "";
  const agentName = props.node?.data.nodeProperties?.agentName ?? "";
  let buttonLabel: string = "";

  const functionSubscriber = useFunctionSubscriber();

  const handleOnClick = () => {
    if (functionSubscriber.navigateToPlexAgentPage) {
      if (plexAgentId === null || plexAgentId === "") {
        functionSubscriber.navigateToPlexAgentPage(null, true);
      } else {
        functionSubscriber.navigateToPlexAgentPage({ Name: agentName }, true);
      }
    }
  };

  if (plexAgentId === null || plexAgentId === "") {
    buttonLabel = "Search Agents";
  } else {
    buttonLabel = "View Details";
  }

  return (
    <Button className="plex-fd-view-plex-agent-details-button" onClick={handleOnClick}>
      {buttonLabel}
    </Button>
  );
};
